import { MessageCircle, Mail } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal, Overline } from "@/components/motion";

export const CtaBanner = ({ title = "Sezonul 2027 se apropie.", subtitle = "Datele frumoase se ocupă primele. Sună-ne sau scrie-ne și rezervă-ți experiența pe mare." }) => (
  <section data-testid="cta-banner" className="border-y border-white/10 bg-deep">
    <div className="mx-auto max-w-[1440px] px-6 py-24 lg:px-12 lg:py-32">
      <Reveal>
        <Overline className="mb-6">Rezervă Experiența</Overline>
        <h2 className="max-w-3xl font-serif text-3xl font-light leading-tight text-ivory sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-mist">{subtitle}</p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-phone-button"
            className="flex items-center justify-center gap-3 bg-gold px-8 py-4 text-xs font-normal uppercase tracking-[0.25em] text-abyss transition-colors duration-300 hover:bg-gold-hover"
          >
            <MessageCircle className="h-4 w-4" /> {CONTACT.phone}
          </a>
          <a
            href={CONTACT.emailHref}
            data-testid="cta-email-button"
            className="flex items-center justify-center gap-3 border border-gold px-8 py-4 text-xs font-normal uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:bg-gold hover:text-abyss"
          >
            <Mail className="h-4 w-4" /> Scrie-ne
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
